import { render } from "./Sport.vue?vue&type=template&id=ecb1c7a0&scoped=true&ts=true"
import script from "./Sport.vue?vue&type=script&lang=ts"
export * from "./Sport.vue?vue&type=script&lang=ts"

import "./Sport.vue?vue&type=style&index=0&id=ecb1c7a0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb1c7a0"]])

export default __exports__